import Api from '../Api';

import { url } from './config';
import { CrmAction } from './types';

const api = new Api<CrmAction>(url);

export default api;
